import { Injectable, ErrorHandler } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { RouterPatchComponent as router } from './app-router-patch.component';
import { UtilityService } from './utility.service';
import { HttpClientService } from './http-client.service';


@Injectable()
export class ErrorLogService implements ErrorHandler {

  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService, ) {
  }

  public handleError(error: any): void {
    try {
      this.logError(this.findOriginalError(error));
    } catch (loggingError) {
      console.group('ErrorHandler');
      console.warn('Error when trying to log error to', this.logError);
      console.error(loggingError);
      console.groupEnd();
    }
  }

  private logError(error: any): void {
    if (error && error.message === 'Timeout has occurred') {
      error.status = 408;
    }
    this.sendToConsole(error);
    // this.sendToServer(error);
    if (error && error.status) {
      router.navigateByUrl.next('serverError/' + error.status);
    } else {
      router.navigateByUrl.next('serverError/' + 500);
    }

  }

  private sendToConsole(error: any): void {
    console.log('-------3-------');
    if (console && console.group && console.error) {
      console.group('Error Log Service');
      console.error(error);
      if (error.statusText) {
        console.error(error.statusText);
      }
      if (error.message) {
        console.error(error.message);
      }
      if (error.stack) {
        console.error(error.stack);
      }
      console.groupEnd();
    }
  }

  private sendToServer(error: any): void {
    console.log('-------4-------');
    this.httpClientService
      .post(this.utilityService.getEnvConfig().loggerServiceUrl,
      {
        errorCode: error.status,
        errorDescription: error.message,
        errorStack: error.stack,
        currentLocation: window.location.href
      }
      )
      .subscribe(
      (httpResponse: HttpResponse<any>): void => { },
      (httpError: HttpErrorResponse): void => {
        console.log('Http error:', httpError);
      }
      )
      ;
  }



  private findOriginalError(error: any): any {
    console.log('-------5-------');
    while (error && error.originalError) {
      error = error.originalError;
    }
    return (error);
  }
}
